import { WalkthroughService } from "@/local-services/storage.service.js";

export const tours = [
  {
    name: "myMovieAddTour",
    id: 1,
    data: [
      {
        target: "#searchinputele", // We're using document.querySelector() under the hood
        header: {
          title: "Get Started"
        },
        content: `Discover any movie based on genre, name, or alternate title!`
      },
      {
        target: ".v-step-1",
        content: "Click here to create a movie"
      }
    ]
  },
  {
    name: "myScheduleDragAndDropTour1",
    id: 2,
    data: [
      {
        target: ".createDragAndDrop", // We're using document.querySelector() under the hood
        header: {
          title: "drag and drop schedule"
        },
        content: "Click here to create a schedule using drag and drop"
      }
    ]
  },
  {
    name: "myScheduleDragAndDropTour2",
    id: 3,
    data: [
      {
        target: ".selectCinemaDandD", // We're using document.querySelector() under the hood
        header: {
          title: "Select Cinema"
        },
        content: "Click here to select Cinema"
      },
      {
        target: ".selectDandDDate", // We're using document.querySelector() under the hood
        header: {
          title: "Select Cinema"
        },
        content: "Click here to select Date"
      }
    ]
  },
  {
    name: "myScheduleDragAndDropTour3",
    id: 4,
    data: [
      {
        target: ".dragMovie", // We're using document.querySelector() under the hood
        header: {
          title: "Drag Movie"
        },
        content: "Drag Movies from here to the right",
        params: {
          placement: "top"
        }
      }
    ]
  }
];

export function getTours(skipFinished = false) {
  let toursWithStatus = tours.map(tour => {
    let walkthrough_status = WalkthroughService.getWalkthoughComplete(tour.id);
    tour.is_complete = walkthrough_status;
    return tour;
  });

  if (skipFinished) {
    toursWithStatus = toursWithStatus.filter(tour => !tour.is_complete);
  }

  return toursWithStatus;
}

export function setTourComplete(walkthrough_id) {
  WalkthroughService.setWalkthroughComplete(walkthrough_id);
}



// WEBPACK FOOTER //
// ./src/helper/tours.js